import { useSelector } from 'react-redux';

export default function useIsInitSuccessInfo() {
    const { hasInited, hasUserStateInited, hasErrorOnInit } = useSelector(s => s.flags);
    const success = hasInited && hasUserStateInited && !hasErrorOnInit;
    return success;
}
